import React, { useEffect } from 'react';
import { Wrapper, Background, Footer, Baby } from './styles';
import { Pattern } from '../../../styles/ThemeComponents';
import Header from '../../../components/Header';
import { Menu } from '../../../components/Menu';
import { usePages } from '../../../hooks/Pages';
import SpeakerGrid from '../../../components/SpeakersGrid';
import FooterLayout from '../../Footer';
import Sponsors from '../../Sponsors';
import Particles from 'react-particles-js';
import { WebGL } from '../../../components/WebglAnimation';

const DefaultLayout: React.FC = ({ children }) => {
  const page = window.location.pathname !== '/';
  const { menu } = usePages();
  return (
    <>
      <Wrapper>
        <Menu menuList={menu} fixedMenu={true} />

        {children}
    
        
      </Wrapper>
      <Sponsors/>
     <FooterLayout/>
     <Particles
        params={{
          particles: {
            lineLinked: {
              enable: false,
            },
            move: {
              speed: 4,
              direction: 'top-right',

              outModes: {
                default: 'out',
                left: 'out',
                right: 'out',
                bottom: 'out',
                top: 'out',
              },
            },
            shape: {
              type: 'circle',
           
            },
            color: { value: '#00fe9b' },

            number: {
              density: {
                enable: true,
                value_area: 2400,
              },
              value: 180,
            },
            size: {
              value: 3,
              random: true,
            },
          },
        }}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: '100%',
          height: '100%',
          zIndex: 0
        }}
      />

  
     
    </>
  );
};

export default DefaultLayout;
